import { render, staticRenderFns } from "./RestoreTemplateVersion.vue?vue&type=template&id=aed33b60&scoped=true"
import script from "./RestoreTemplateVersion.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestoreTemplateVersion.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RestoreTemplateVersion.vue?vue&type=style&index=0&id=aed33b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed33b60",
  null
  
)

export default component.exports